import React, { Suspense, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider, Grid, theme } from 'antd';
import './App.css';
import Router from './Routes';
import { GlobalProvider } from './Components/Shared/GlobalContext/GlobalContext';
import LoadingOverlay from './Components/Shared/LoadingOverlay/LoadingOverlay';
import { useTheme } from './Components/Shared/GlobalContext/ThemeContext';
import { useTranslation } from 'react-i18next';
import enUS from 'antd/es/locale/en_US';
import frFR from 'antd/es/locale/fr_FR';
import esES from 'antd/es/locale/es_ES';
import deDE from 'antd/es/locale/de_DE';
import zhCN from 'antd/es/locale/zh_CN';
import arEG from 'antd/es/locale/ar_EG';
import i18n from './i18n';
import { RTL_LANGUAGES } from './Constants/language';

const antdLocales = {
  en: enUS,
  fr: frFR,
  es: esES,
  de: deDE,
  zh: zhCN,
  ar: arEG
};
const { useBreakpoint } = Grid;

function App() {
  const { t } = useTranslation();
  const [antdLocale, setAntdLocale] = useState(antdLocales.en);
  const [direction, setDirection] = useState('ltr');

  const { isDarkMode } = useTheme();
  const screens = useBreakpoint();
  const isMobile = screens.xs;

  const { darkAlgorithm, defaultAlgorithm } = theme;
  const themeConfig = {
    algorithm: isDarkMode
      ? darkAlgorithm
      : defaultAlgorithm,
    token: {
      primaryColor: '#7F56D9',
    },
    components: {
      Card: {
        padding: screens.md ? 12 : 24,
      },
      Modal: {
        borderRadiusLG: isMobile ? 0 : 8,
      }
    },
  };

  useEffect(() => {
    const updateAntdLocale = () => {
      const lang = i18n.language.split('-')[0];
      setAntdLocale(antdLocales[lang] || antdLocales.en);

      setDirection(RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr');
    };
    updateAntdLocale();
    i18n.on('languageChanged', updateAntdLocale);
    return () => i18n.off('languageChanged', updateAntdLocale);
  }, []);

  return (
    <ConfigProvider
      theme={themeConfig}
      locale={antdLocale}
      direction={direction}
    >
      <Suspense fallback={t('loading...')}>
        <GlobalProvider>
          <LoadingOverlay />
          <RouterProvider router={Router} />
        </GlobalProvider>
      </Suspense>
    </ConfigProvider >
  );
}

export default App;
